import { useEffect } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import { useRouter } from 'next/router';
import { useCountDown } from 'ahooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { activityTime } from '@/data/ecocreditsday';

export default function PageCountDown() {
    const { t } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const { getSystemTime } = useGlobal();
    const start = getSystemTime();
    const end = activityTime[locale as keyof typeof locale][1] || activityTime.jp[1];
    const [countdown, formattedRes] = useCountDown({ leftTime: end - start });

    useEffect(() => {
        const scene = new ScrollMagic.Scene({
            triggerElement: '.firstKv',
            offset: 1000, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 400,
        });
        const timeline = new TimelineMax();
        const tweenA1 = TweenMax.to('.count-down__title', 0.5, { opacity: 0.9 });
        const tweenA2 = TweenMax.to('.count-down__desc', 0.3, { opacity: 0.9 });
        const tweenA3 = TweenMax.to('.count-down__box', 0.3, { opacity: 0.9 });
        timeline.add(tweenA1).add(tweenA2, 0.1).add(tweenA3, 0.2);
        scene.setTween(timeline);
        controllerDay.addScene(scene);

        return () => {
            scene && scene?.destroy();
        };
    }, []);

    return (
        <div className={`${styles.pageCountDown} pageCountDown`}>
            <div className="count-down__title">{t('pageCountDown.title')}</div>
            {t('pageCountDown.desc') && <div className="count-down__desc">{t('pageCountDown.desc')}</div>}
            <div className="count-down__box">
                <div className="count-down__num">
                    <div className="num-box">{formattedRes.days}</div>
                    <div className="num-unit">{t('pageCountDown.day')}</div>
                </div>
                <span className="count-down__split">:</span>
                <div className="count-down__num">
                    <div className="num-box">{formattedRes.hours}</div>
                    <div className="num-unit">{t('pageCountDown.hours')}</div>
                </div>
                <span className="count-down__split">:</span>
                <div className="count-down__num">
                    <div className="num-box">{formattedRes.minutes}</div>
                    <div className="num-unit">{t('pageCountDown.minute')}</div>
                </div>
                <span className="count-down__split">:</span>
                <div className="count-down__num">
                    <div className="num-box">{formattedRes.seconds}</div>
                    <div className="num-unit">{t('pageCountDown.second')}</div>
                </div>
            </div>
        </div>
    );
}
